<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">دوره های تخصصی هوش مصنوعی ناباکو</h2>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold my-auto">هوش مصنوعی (Artificial Intelligence)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            هوش مصنوعی به عنوان ابزاری قدرتمند، فرصت‌های بزرگی را برای بهبود تصمیم‌گیری مالی و پیش‌بینی روندهای اقتصادی ایجاد کرده است. در آکادمی ما، شما با کاربردهای هوش مصنوعی، الگوریتم‌ها و چگونگی استفاده از این تکنولوژی آشنا خواهید شد.
                            <br>
                            <strong>موضوعات این دوره:</strong>
                            <br>
                            <ul>
                                <li>مفاهیم اولیه هوش مصنوعی و یادگیری ماشین.</li>
                                <li>کاربردهای هوش مصنوعی در پیش‌بینی‌های مالی.</li>
                                <li>نحوه تحلیل داده‌های بزرگ (Big Data) برای تصمیم‌گیری‌های مالی.</li>
                                <li>نقش هوش مصنوعی در شخصی‌سازی خدمات مالی.</li>
                                <li>چالش‌های اخلاقی و امنیتی مرتبط با هوش مصنوعی.</li>
                            </ul>
                            <button class="btn-gold my-2 mx-3 py-2" @click="router.push({name:'period'})">شروع</button>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img3.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">بلاکچین (Blockchain)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            بلاکچین یک فناوری انقلابی است که زیرساخت بسیاری از ارزهای دیجیتال و فرآیندهای مالی را تشکیل می‌دهد. در آکادمی ناباکو، شما با اصول بلاکچین، نحوه کارکرد آن و کاربردهایش در دنیای واقعی آشنا خواهید شد.
                            <br>
                            <strong>موضوعات این دوره:</strong>
                            <br>
                            <ul>
                                <li>ساختار و عملکرد بلاکچین.</li>
                                <li>تفاوت بلاکچین عمومی و خصوصی.</li>
                                <li>ارزهای دیجیتال و تأثیر بلاکچین بر آینده مالی.</li>
                                <li>کاربرد بلاکچین در صنعت نفت و گاز و دیگر صنایع.</li>
                                <li>امنیت و چالش‌های فناوری بلاکچین.</li>
                            </ul>
                            <button class="btn-gold my-2 mx-3 py-2" @click="router.push({name:'period'})">شروع</button>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img3.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold my-auto">سواد مالی (Financial Literacy)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            سواد مالی به معنای داشتن دانش و مهارت لازم برای مدیریت مؤثر امور مالی شخصی و سرمایه‌گذاری است. در آکادمی ناباکو، شما یاد می‌گیرید چگونه بودجه‌بندی کنید، پس‌انداز داشته باشید، بدهی‌ها را مدیریت کنید و تصمیم‌های مالی هوشمندانه بگیرید.                            <br>
                            <strong>موضوعات این دوره:</strong>
                            <br>
                            <ul>
                                <li>اصول مدیریت مالی شخصی.</li>
                                <li>نحوه تحلیل فرصت‌های سرمایه‌گذاری.</li>
                                <li>درک مفاهیم کلیدی مانند نرخ بهره و ارزش زمان پول.</li>
                                <li>آموزش ابزارهای مدیریت بودجه و سرمایه‌گذاری.</li>
                            </ul>
                            <button class="btn-gold my-2 mx-3 py-2" @click="router.push({name:'period'})">شروع</button>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img2.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <h6>
                به آکادمی ناباکو بپیوندید و یادگیری خود را به سطح جدیدی ببرید. هم‌اکنون با کلیک بر روی دوره  شروع کنید!
                <br>
                <br>
                هوش مصنوعی ناباکو امکان برگزاری این دوره ها برای سازمان ها و شرکت ها به صورت خصوصی را دارد با کارشناسان مجموعه ما در تماس باشین
            </h6>
        </div>
        <!-- <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">دسته بندی های دوره های تخصصی هوش مصنوعی ناباکو</h2>
            <div class="row">
                <div class="col-lg-4 col-md-6 my-5">
                    <div class="card w-100">
                        <img src="../../assets//services-img/img1.svg" class="w-100" alt="">
                        <h5 class="mt-4">هوش مصنوعی</h5>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 my-5">
                    <div class="card w-100">
                        <img src="../../assets//services-img/img3.svg" class="w-100" alt="">
                        <h5 class="mt-4">بلاک چین</h5>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 my-5">
                    <div class="card w-100">
                        <img src="../../assets//services-img/img2.svg" class="w-100" alt="">
                        <h5 class="mt-4">سواد مالی</h5>
                    </div>
                </div>
                <h6>ویدیوهای آموزشی دوره ها به زودی بارگذاری می شوند.</h6>
            </div>
        </div> -->
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from 'vue-router';

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)
        const router = useRouter()

        return {
            router
        }
    }
 })
</script>
<style lang="scss" scoped>
.card {
    border: solid 1px #cfcfcf;
}
</style>